const STOPS = [[255, 230, 0], [255, 43, 214], [0, 255, 208], [124, 255, 0], [255, 106, 0], [255, 230, 0]];

const PALETTE = Array.from({ length: 256 }, (_, i) => {
  const x = (i / 256) * (STOPS.length - 1);
  const a = STOPS[Math.floor(x)], b = STOPS[Math.floor(x) + 1];
  const f = x - Math.floor(x);
  return a.map((v, j) => Math.round(v + (b[j] - v) * f));
});

const SCALE = 10;

export const microdot = {
  id: "microdot",
  name: "Microdot",
  subtitle: "80s acid house plasma, printed with tiny black dots",
  init(w, h) {
    const c = document.createElement("canvas");
    c.width = Math.ceil(w / SCALE);
    c.height = Math.ceil(h / SCALE);
    const cx = c.getContext("2d");
    return { c, cx, img: cx.createImageData(c.width, c.height), gap: Math.max(16, Math.round(Math.min(w, h) / 36)) };
  },
  draw(ctx, w, h, t, s, p) {
    const { c, cx, gap, img } = s;
    const d = img.data;
    const tt = t * 1.6;
    const bright = 0.88 + p * 0.12;
    for (let y = 0; y < c.height; y++) {
      for (let x = 0; x < c.width; x++) {
        const v = Math.sin(x * 0.09 + tt) + Math.sin(y * 0.11 - tt * 0.8)
          + Math.sin((x + y) * 0.06 + tt * 0.6) + Math.sin(Math.hypot(x - c.width / 2, y - c.height / 2) * 0.12 - tt * 1.3);
        const col = PALETTE[Math.floor(((v + 4) / 8) * 255 + tt * 20) & 255];
        const i = (y * c.width + x) * 4;
        d[i] = col[0] * bright;
        d[i + 1] = col[1] * bright;
        d[i + 2] = col[2] * bright;
        d[i + 3] = 255;
      }
    }
    cx.putImageData(img, 0, 0);
    ctx.globalCompositeOperation = "source-over";
    ctx.imageSmoothingEnabled = true;
    ctx.drawImage(c, 0, 0, w, h);

    ctx.fillStyle = "#050505";
    ctx.beginPath();
    const cxm = w / 2, cym = h / 2;
    for (let y = gap / 2; y < h + gap; y += gap) {
      for (let x = gap / 2; x < w + gap; x += gap) {
        const dx = x + Math.sin(y * 0.015 + tt) * gap * 0.45;
        const dy = y + Math.cos(x * 0.013 - tt * 0.9) * gap * 0.45;
        const dist = Math.hypot(dx - cxm, dy - cym);
        const r = gap * (0.14 + 0.1 * (1 + Math.sin(dist * 0.02 - tt * 2.2)));
        ctx.moveTo(dx + r, dy);
        ctx.arc(dx, dy, r, 0, Math.PI * 2);
      }
    }
    ctx.fill();
  },
};
